import { DckActionCreators } from "dck-redux"
import store from "store"
import { INVALID_TOKEN, parseFetchError } from "./utils"
import reduxStore from '../store'

/**
 * Helpers for blocking "fetch" call
 * 
 * @param {*} restCallback 
 * @param {*} checkAccessToken 
 * @returns 
 */
async function helperService(restCallback, checkAccessToken) {

  try {

    let resp = {}
    if(checkAccessToken) {
      const sessionData = store.get("sessionData")
      resp = await restCallback(sessionData.access_token)
    }
    else {
      resp = await restCallback()
    }

    return resp.hasOwnProperty('body') ? resp.body
      : (resp.hasOwnProperty('data') ? resp.data
        : (resp.hasOwnProperty('message') ? resp.message : resp))
  }
  catch(error) {

    console.error(error)
    const content = parseFetchError(error)

    if (content.text === INVALID_TOKEN) {
      reduxStore.dispatch(DckActionCreators.signOut())
    }

    throw content
  }
}

// Caller
function blockingFetchService(restCallback, callbackSuccess, callbackError, callbackFinally) {
  helperService(restCallback, true)
    .then(callbackSuccess)
    .catch(callbackError)
    .finally(callbackFinally)
}

function blockingFetchServiceNoToken(restCallback, callbackSuccess, callbackError, callbackFinally) {
  helperService(restCallback, false)
    .then(callbackSuccess)
    .catch(callbackError)
    .finally(callbackFinally)
}

export { blockingFetchService, blockingFetchServiceNoToken }



// WEBPACK FOOTER //
// ./src/lib/blockingFetch.js